<template>
  <v-card style="min-height: 205px;">
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="d-flex flex-row">
          <pie-bullet :color="colors[code]" :value="percentage" class="mr-2"/>
          <span :style="{ textDecoration: 'underline', textDecorationColor: colors[code] }">{{ code }} ({{ formatValue(percentage, 0) }}%)</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <marketing-spend-detail-channel-touchpoint :data="data.touchpoints" :colors="currentClientObject.colors"/>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import MarketingSpendDetailChannelTouchpoint from '@/components/simulationDetails/MarketingSpendDetailChannelTouchpoint.vue'
import PieBullet from '@/components/simulationDetails/PieBullet.vue'
import numbro from 'numbro'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('clients', [
      'currentClientObject'
    ]),
    percentage: function () {
      if (this.total > 0) {
        return 100 * this.data.invest / this.total
      } else {
        return 0
      }
    }
  },
  methods: {
    formatValue: function (value, mantissa = 1) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: mantissa,
        optionalMantissa: true
      })
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    code: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: false
    }
  },
  components: {
    MarketingSpendDetailChannelTouchpoint,
    PieBullet
  }
}
</script>
